// Foundations
import { Component, Input, OnInit } from '@angular/core';
import { UnitConversionPipe } from 'src/app/pipes/unit-conversion.pipe';

// Models
import { PetTileFormInfo } from '../pet-tile-form/pet-tile-form.component';

@Component({
  selector: 'app-pet-tile-review',
  templateUrl: './pet-tile-review.component.html',
  styleUrls: ['./pet-tile-review.component.scss'],
})
export class PetTileReviewComponent implements OnInit {
  @Input() petInfo: PetTileFormInfo;

  constructor(private convertUnit: UnitConversionPipe) {}

  ngOnInit() {}

  get breedNameList(): string {
    const breedStrings = this.petInfo.breeds
      ? this.petInfo.breeds.map((breed) => breed.breed.label)
      : [];
    if (breedStrings.length > 0) {
      return breedStrings.join(', ');
    } else {
      return 'unknown';
    }
  }

  get petWeightObject() {
    if (this.petInfo.weight && typeof this.petInfo.weight === 'object') {
      return this.petInfo.weight;
    }
    return this.petInfo;
  }

}
